import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const LinkToFrameworkModalState = Record({
    isVisible: false,
    showAgeBandSelector: false,
    formIdentifier: false,
    areaRefinements: List(),
    statementRefinements: List(),
    childId: null,
    framework: null,
    variant: null,
    selectedAreaId: null,
    selectedSubAreaId: null,
    previousSubAreaId: null,
    selectedAgeBandId: null,
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) =>
            state.merge({
                isVisible: true,
                statementRefinements: List(payload.statementRefinements),
                areaRefinements: List(payload.areaRefinements),
                childId: payload.childId,
                formIdentifier: payload.formIdentifier,
                framework: payload.framework,
                variant: payload.variant,
            }),
        [Actions.showAgeBandSelector.type]: (state, {payload}) =>
            state.merge({
                showAgeBandSelector: payload.show,
            }),
        [Actions.selectArea.type]: (state, {payload}) =>
            state.merge({
                selectedAreaId: payload.area,
                previousSubAreaId: payload.currentSubarea,
                selectedSubAreaId: payload.nextSubarea,
                selectedAgeBandId: null,
            }),
        [Actions.selectSubArea.type]: (state, {payload}) =>
            state.merge({
                previousSubAreaId: payload.currentSubarea,
                selectedSubAreaId: payload.subArea,
                selectedAgeBandId: null,
            }),
        [Actions.selectAgeBand.type]: (state, {payload}) =>
            state.merge({
                selectedAgeBandId: payload.ageBand,
                showAgeBandSelector: false,
            }),
        [Actions.hide.type]: () => new LinkToFrameworkModalState(),
    },
    new LinkToFrameworkModalState(),
);
